<template>
  <v-card class="mb-3" color="grey lighten-3">
    <v-card-title>
      {{ customerReport.name }}
    </v-card-title>
    <v-card-subtitle>
      {{ formatHeaderDate(startDate) }} {{ $t('to') }} {{ formatHeaderDate(endDate) }}
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col class="mb-3" xl="6">
          <fleet-health-trends :customer-report="customerReport" />
        </v-col>
        <v-col class="mb-3" xl="6">
          <temperature-violation-trends :customer-report="customerReport" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mb-3">
          <vehicle-issue-trends :customer-report="customerReport"></vehicle-issue-trends>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mb-3">
          <daily-stats :customer-report="customerReport"></daily-stats>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import FleetHealthTrends from '@/components/report/fleet-health/FleetHealthTrends'
import VehicleIssueTrends from '@/components/report/fleet-health/VehicleIssueTrends'
import DailyStats from '@/components/report/fleet-health/DailyStats'
import TemperatureViolationTrends from '@/components/report/fleet-health/TemperatureViolationTrends'
import Moment from 'moment-timezone'

export default {
  name: 'FleetHealthReportCard',
  components: {
    TemperatureViolationTrends,
    FleetHealthTrends,
    VehicleIssueTrends,
    DailyStats
  },
  props: {
    customerReport: {
      type: Object
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    comparison: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerBgVariant () {
      return this.comparison ? 'secondary' : 'light'
    },
    headerTextVariant () {
      return this.comparison ? 'white' : 'normal'
    },
    cardHeaderBgVariant () {
      return this.comparison ? 'dark' : 'primary'
    },
    cardBorderVariant () {
      return this.comparison ? 'dark' : 'primary'
    }
  },
  methods: {
    formatHeaderDate (date) {
      // parseZone keeps the offset the report was generated with, so the header always matches the range that was
      // selected in the form (and queried on the back end) rather than shifting with the viewer's browser timezone.
      return Moment.parseZone(date).format('ll')
    }
  }
}
</script>

<style scoped>
</style>
